export enum LayoutModes {
  list = 'list',
  grid = 'grid',
}
